const loading = [
  { name: 'Address', path: 'address', meta: {} },
  { name: 'Housing', path: 'housing', meta: {} },
  { name: 'FurnitureTransport', path: 'access', meta: {} },
  { name: 'ParkingArea', path: 'parking', meta: {} },
];

const children = [
  ...loading.map(elem => ({
    path: elem.path,
    component: elem.name,
    name: `loading${elem.name}`,
    meta: elem.meta,
  })),
];


export default children;
